export const industrialLaserTheme = {
    id: 'industrial-laser',
    label: 'Industrial Laser',
    description: 'Default. Rugged, readable, easiest on the eyes for long sessions.',
    paletteMode: 'dark',
    tokens: {
        app: { bg: '#111418', bgElevated: '#181D23' },
        surface: {
            nav: '#111418',
            panel: '#2B3037',
            panelAlt: '#46515E',
            input: '#1B2027',
        },
        border: {
            default: 'rgba(232, 237, 242, 0.14)',
            strong: 'rgba(30, 143, 255, 0.50)',
        },
        text: {
            primary: '#E8EDF2',
            secondary: '#A1ABB7',
            disabled: '#687380',
            inverse: '#061016',
        },
        action: {
            primary: '#1E8FFF',
            primaryHover: '#63B5FF',
            secondary: '#FF6A1A',
        },
        state: {
            success: '#41FF8A',
            warning: '#FF6A1A',
            error: '#E53935',
            info: '#1E8FFF',
        },
        data: {
            seriesA: '#1E8FFF',
            seriesB: '#FF6A1A',
            seriesC: '#41FF8A',
            seriesD: '#8B5CF6',
        },
        effect: {
            glow: 'rgba(30, 143, 255, 0.38)',
            shadow: '0 18px 54px rgba(0, 0, 0, 0.34)',
        },
    },
};
//# sourceMappingURL=industrial-laser.js.map